module.exports = __webpack_public_path__ + "static/pp_standaryzacja-5c643137c8955b9c9b6074538a51a8ab.gif";